import React from 'react'
import PropTypes from 'prop-types'
import styles from './footer-nav.module.css'
import { Link, useStaticQuery, graphql } from 'gatsby'
import { Affiliates } from '../model/affiliates'

const activeStyle = {
  color: '#ffffff',
  fontWeight: 400,
  textDecoration: 'none',
  borderBottom: '3px solid #00CDA8',
}

const styleSmall = {
  color: '#b6a4ea',
  fontWeight: 100,
  textDecoration: 'none',
}

const activeStyleSmall = {
  color: '#d2c7f3',
  fontWeight: 400,
  textDecoration: 'none',
  borderBottom: '1px solid #00CDA8',
}

const ListLink = (props) => (
  <li className={styles.listLink}>
    <Link to={props.to} activeStyle={activeStyle}>
      {props.children}
    </Link>
  </li>
)

const ListLinkSmall = (props) => (
  <li className={styles.listLinkSmall}>
    <Link to={props.to} style={styleSmall} activeStyle={activeStyleSmall}>
      {props.children}
    </Link>
  </li>
)

const OutboundListLink = (props) => (
  <li className={styles.listLink}>
    <a href={props.href}>{props.children}</a>
  </li>
)

OutboundListLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
}

ListLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
}

ListLinkSmall.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
}

const FooterNav = () => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(
        sort: { fields: [frontmatter___date], order: DESC }
        filter: { fields: { slug: { ne: "/terms/" } } }
      ) {
        edges {
          node {
            excerpt
            fields {
              slug
            }
            frontmatter {
              date(formatString: "MMMM DD, YYYY")
              title
              category
            }
          }
        }
      }
    }
  `)
  const posts = data.allMarkdownRemark.edges
  const news = posts.filter(({ node }) => node.frontmatter.category === 'News').slice(0, 10) // only show last x items

  return (
    <ul className={styles.nav}>
      <ListLink to="/">Business Energy</ListLink>
      <OutboundListLink href={Affiliates.SwitchPal.Payments.Footer}>
        Barclaycard Business EPOS Systems
      </OutboundListLink>
      <OutboundListLink href={Affiliates.FundOnion}>Business Loans</OutboundListLink>
      <OutboundListLink href={Affiliates.SwitchPal.Boadband.Footer}>
        Business Broadband
      </OutboundListLink>
      <OutboundListLink href={Affiliates.Switchd}>Home Energy</OutboundListLink>
      <OutboundListLink href={Affiliates.MakeMyHouseGreen}>Home Solar Panels</OutboundListLink>
      {/* <ListLink to='/news/'>News</ListLink> */}
      {/* <ListLink to='/about/'>About Us</ListLink> */}
      <ListLink to="/terms/">Terms & Conditions</ListLink>
      <p className={styles.sectionTitle}>Guides & Tools</p>
      {posts
        .filter(({ node }) => node.frontmatter.category === 'Guide')
        .map(({ node }) => {
          return (
            <ListLinkSmall key={node.fields.slug} to={node.fields.slug}>
              {node.frontmatter.title}
            </ListLinkSmall>
          )
        })}
      {/* {news.length > 0 && <p className={styles.sectionTitle}>Latest News</p>}
      {news.map(({ node }) => {
        return (
          <ListLinkSmall key={node.fields.slug} to={node.fields.slug}>
            {node.frontmatter.title}
          </ListLinkSmall>
        )
      })} */}
    </ul>
  )
}

export default FooterNav
